import { firestore } from '../constants/firebase/config';

// Backend endpoint URLs used to be compiled into the bundle, which is why moving
// off the unreachable me-south-1 lambdas needs a web redeploy and a store release
// for the native builds. They now resolve from settings/endpoints at runtime, so
// the next move is a document edit instead. These defaults are the fallback when
// the document is missing or unreadable.
const DEFAULTS = {
    getUserRecord: 'https://europe-west1-metadoc-app.cloudfunctions.net/getUserRecord',
    updateUser: 'https://europe-west1-metadoc-app.cloudfunctions.net/updateUser',
    attachCard: 'https://europe-west1-metadoc-app.cloudfunctions.net/attachCard',
};

let cache;
let inflight;

async function load() {
    try {
        const snap = await firestore().collection('settings').doc('endpoints').get();
        const overrides = (snap && snap.data && snap.data()) || {};
        cache = { ...DEFAULTS, ...overrides };
    } catch (error) {
        console.log('endpoints: using compiled defaults', error?.message || error);
        cache = { ...DEFAULTS };
    }
    return cache;
}

// Resolved once per session, then served from memory.
export async function getEndpoint(name) {
    if (cache) return cache[name] || DEFAULTS[name];
    if (!inflight) {
        inflight = load();
    }
    const resolved = await inflight;
    return resolved[name] || DEFAULTS[name];
}
